import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values  = { url: String }
  static targets = [
    "confirmModal",
    "confirmStep",
    "confirmButton", "confirmText", "confirmSpinner",
    "runningStep",
    "statusMessage"
  ]

  connect() {
    // Reset to confirm state each time the modal is opened
    this.confirmModalTarget.addEventListener("show.bs.modal", () => this._resetState())
  }

  async confirm() {
    this.confirmTextTarget.classList.add("d-none")
    this.confirmSpinnerTarget.classList.remove("d-none")
    this.confirmButtonTarget.disabled = true

    try {
      const response = await fetch(this.urlValue, {
        method: "POST",
        headers: {
          "X-CSRF-Token": document.querySelector('meta[name="csrf-token"]').getAttribute("content"),
          "Accept": "text/html"
        }
      })

      if (response.ok || response.redirected) {
        this._showRunning("Analysis queued — this can take several minutes. You can navigate away and results will appear when ready.")
      } else {
        this._showRunning("Something went wrong. Please refresh and try again.", { error: true })
      }
    } catch {
      this._showRunning("Could not reach the server. Check your connection and try again.", { error: true })
    }
  }

  _showRunning(message, { error = false } = {}) {
    this.confirmStepTarget.classList.add("d-none")
    this.runningStepTarget.classList.remove("d-none")
    this.statusMessageTarget.textContent = message

    if (error) {
      const bar = this.runningStepTarget.querySelector(".progress-bar")
      bar?.classList.remove("progress-bar-animated", "bg-primary")
      bar?.classList.add("bg-danger")
    }
  }

  _resetState() {
    this.confirmStepTarget.classList.remove("d-none")
    this.runningStepTarget.classList.add("d-none")

    this.confirmTextTarget.classList.remove("d-none")
    this.confirmSpinnerTarget.classList.add("d-none")
    this.confirmButtonTarget.disabled = false

    const bar = this.runningStepTarget.querySelector(".progress-bar")
    if (bar) {
      bar.classList.add("progress-bar-animated", "bg-primary")
      bar.classList.remove("bg-danger")
    }
  }
}
